import { Fragment, useEffect, useMemo, useState } from 'react';
import { fetchEmotes, parseShortcodes, type Emote } from '../utils/emotes';

/**
 * `:slug:` kısayollarını içeren düz metni, görsellere çevirerek render eder.
 * Ham HTML asla üretilmez — metin parçalanıp React elemanlarına dönüştürülür,
 * bu yüzden XSS riski taşımaz (dangerouslySetInnerHTML kullanılmaz).
 */
export function EmoteText({ text, className, imgClassName }: { text: string; className?: string; imgClassName?: string }) {
  const [emotes, setEmotes] = useState<Emote[]>([]);

  useEffect(() => {
    let alive = true;
    fetchEmotes().then(list => { if (alive) setEmotes(list); });
    return () => { alive = false; };
  }, []);

  const emoteBySlug = useMemo(() => new Map(emotes.map(e => [e.slug, e])), [emotes]);
  const parts = useMemo(() => parseShortcodes(text, emoteBySlug), [text, emoteBySlug]);

  return (
    <span className={className}>
      {parts.map((part, i) =>
        part.type === 'text' ? (
          <Fragment key={i}>{part.value}</Fragment>
        ) : (
          <img
            key={i}
            src={part.emote!.image_url!}
            alt={`:${part.slug}:`}
            title={part.emote!.name}
            className={imgClassName ?? 'inline-block h-5 w-5 align-text-bottom mx-0.5'}
            loading="lazy"
          />
        )
      )}
    </span>
  );
}
